import PropTypes from 'prop-types';

const ChevronLeft2 = ({ color, size, ...props }) => (
    <svg viewBox="0 0 20 20" width={size} height={size} {...props}>
        <path
            d="M11.72 15.53a.75.75 0 1 0 1.06-1.06L8.31 10l4.47-4.47.052-.056a.75.75 0 0 0-1.056-1.056l-.056.052-5 5a.75.75 0 0 0 0 1.06z"
            fill={color}
        />
    </svg>
);

export default ChevronLeft2;

ChevronLeft2.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
